export default {
  namespaced: true,
  state: {
    tabbarHeight: 0,
    loginTooltipHeight: 0,
    isPIPLAuthorized: false // false: unauthorized; true: authorized
  },
  mutations: {
    getTabbarHeight(state, data) {
      state.tabbarHeight = Number(data);
    },
    setLoginTooltipHeight(state, data) {
      state.loginTooltipHeight = data;
    },
    async setPIPLAuthorizedStatus(state, data) {
      state.isPIPLAuthorized = data;
    }
  }
};
